import React, { useState, useContext } from 'react';
import GaugeChart from 'react-gauge-chart';
import CTAButton from '/src/Components/CTAButton/CTAButton';
import UserPersonalInfoForm from '/src/Components/UserPersonalInfoForm/UserPersonalInfoForm';
import { WindowSizeContext } from '/src/App';
import { usePropertyGaLogging } from '/src/contexts/PropertyGaLoggingContext';

import './style.css';

const HowWorriedShouldIBe = ({
    type = "sudden-costs",
    meterLevel,
    sentence,
    userPersonalInfo
}) => {
    // const { LOG_GA_EVENT } = useContext(AddressSearchContext);
    const { handleLoggingGaEventFromProperty } = usePropertyGaLogging();
    // console.log('WORRIED INPUTS', meterLevel, sentence, userPersonalInfo);
    const [showFormStatus, setShowFormStatus] = useState(false);
    const { deviceType } = useContext(WindowSizeContext);
    let GALogEventId = "customize_button_sudden_costs";
    let category = "sudden costs"
    if (type === "recurring-bills") {
        category = "recurring expenses"
        GALogEventId = "customize_button_opex";
    } else if (type === "long-term-value") {
        category = "long-term value"
        GALogEventId = "customize_button_ltv";
    }

    const title = `How worried should I be about ${category}?`

    const needleColors = [
        "#34C759", 
        "#66C237", 
        "#93BD15", 
        "#edf051", 
        "#ffe570", 
        "#FFD60A", 
        "#FFB007", 
        "#FF8A04", 
        "#FF5C31", 
        "#FF3B30"  
    ]

    const getNeedleColor = (level) => {
        return needleColors[level-1];
    }

    let needleColor = "#666666";
    let meterNumber = 0;
    let isCompleted = false;
    let sentenceToUse = "We have three short questions that will help us personalize our analysis to your specific situation."

    if (userPersonalInfo) {

        isCompleted = userPersonalInfo.isComplete || false;

        if (isCompleted && meterLevel) {
            needleColor = getNeedleColor(meterLevel);
            meterNumber = meterLevel / 10;
            sentenceToUse = sentence;
        }
    }

    // Truncate at the nearest word boundary
    const truncateAtWord = (str, maxLength) => {
        if (str.length <= maxLength) return str;
        
        const truncated = str.substr(0, maxLength);
        return truncated.substr(0, truncated.lastIndexOf(' ')) + '...';
    };

    // Usage:
    // const truncatedSentence = truncateAtWord(sentenceToUse, 250);
    const truncatedSentence = sentenceToUse;

    // Toggle the form status to opposite of what it is
    const handleShowFormStatusToggle = () => {
        setShowFormStatus(!showFormStatus);
        handleLoggingGaEventFromProperty(GALogEventId);
    }

    return (
        <div className={`how-worried-should-i-be-container ${deviceType}`}>
            {showFormStatus &&
                <UserPersonalInfoForm handleOutsideClick={handleShowFormStatusToggle} />
            }
            <div className="how-worried-should-i-be-header">
                <span className="how-worried-should-i-be-header-text text-align-center">{title}</span>
            </div>
            <div className={`how-worried-should-i-be-results-container ${deviceType} ${isCompleted ? 'completed' : ''}`}>
                <div className={`how-worried-should-i-be-gauge-container ${isCompleted ? '' : 'opaque'} ${deviceType}`}>
                    <GaugeChart
                        id={`how-worried-should-i-be-gauge`}
                        nrOfLevels={10}
                        colors={needleColors}
                        arcWidth={0.25}
                        percent={meterNumber}
                        textColor="transparent"
                        needleScale={.65}
                        needleColor={needleColor}
                        needleBaseColor="#666666"
                        className="how-worried-should-i-be-gauge"
                        hideText={true}
                        style={{
                            height: '100%',
                        }}
                    />
                </div>
                <div className="how-worried-should-i-be-results-text-container">
                    <p className={`how-worried-should-i-be-results-text text-align-center ${!isCompleted ? 'add-data-cta' : ''}`}>{truncatedSentence}</p>
                    {!isCompleted &&
                        <CTAButton
                            text="Customize"
                            onClick={handleShowFormStatusToggle}
                        />
                    }
                </div>
            </div>
        </div>
    )
}

export default HowWorriedShouldIBe;